import hostname from "../api/config.host";
import { fetchWrapper } from "../api/fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;
interface QueriesInBizLeaderDashboardParams {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[]; // Multiple
  type: string;
  dimension: string[];
  start_date?: string;
  end_date?: string;
  period_type?: string;
}

interface OverviewConversionsMobileQueryParams {
  oauthTokenHeader: string;
  queryId: string;
  startDate: string;
  endDate: string;
  timeUnit: string;
  websiteSharedUids?: string[];
  dimensions?: string[];
  type: string;
  campaignId?: string;
  adgroupId?: string;
  matchtype?: string;
  kwId?: string;
  country?: string;
  trafficSource?: string;
}

interface BizDevelopmentParams {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[]; // Multiple
  type: string;
  dimension: string[];
  // start_date?: string;
  // end_date?: string;
  // period_type?: string;
}

function getOverviewAccountSummaryDataInBizLeaderDashboardMobile(
  params: QueriesInBizLeaderDashboardParams,
) {
  const {
    oauthTokenHeader,
    queryId,
    websiteSharedUids = [],
    type,
    dimension = [],
    start_date,
    end_date,
    period_type,
  } = params;
  const searchParams = new URLSearchParams();
  if (start_date) {
    searchParams.append("start_date", start_date);
  }
  if (end_date) {
    searchParams.append("end_date", end_date);
  }
  if (type) {
    searchParams.append("type", type);
  }
  if (period_type) {
    searchParams.append("period_type", period_type);
  }
  if (websiteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", websiteSharedUids[0]);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;

  const requestBody = {
    website_shared_uid: websiteSharedUids,
    dimension,
  };

  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}

function getDimensionInBizDashboardMobile(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/dimensions/`,
    oauthTokenHeader,
  );
}

function getOverviewConversionsMobileData(
  params: OverviewConversionsMobileQueryParams,
) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    timeUnit,
    websiteSharedUids = [],
    dimensions = [],
    type,
    campaignId,
    adgroupId,
    matchtype,
    kwId,
    country,
    trafficSource,
  } = params;
  const searchParams = new URLSearchParams();
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("time_unit", timeUnit);
  searchParams.append("type", type);
  if (campaignId) searchParams.append("campaign_id", campaignId);
  if (adgroupId) searchParams.append("adgroup_id", adgroupId);
  if (matchtype) searchParams.append("matchtype", matchtype);
  if (kwId) searchParams.append("kw_id", kwId);
  if (country) searchParams.append("country", country);
  if (trafficSource) searchParams.append("traffic_source", trafficSource);
  if (websiteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", websiteSharedUids[0]);
  }

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  const requestBody = {
    website_shared_uid: websiteSharedUids,
    dimension: dimensions,
  };

  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}

function getOverviewConversionsTrafficSourcesMobile(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/traffic_sources/`, oauthTokenHeader);
}

function getOverviewConversionsGeosMobile(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/geos/`, oauthTokenHeader);
}

function getOverviewConversionsFilterOptionsDataForCampaignAdgroupKeyword(
  queryId: any,
  oauthTokenHeader: any,
  type: any,
  websiteSharedUids: any[] = [],
  dimensions: any[] = [],
  trafficSource: any,
  account_shared_uid?: any,
  campaign_status?: any,
) {
  const searchParams = new URLSearchParams();
  searchParams.append("type", type);
  if (trafficSource) searchParams.append("traffic_source", trafficSource);
  if (account_shared_uid !== undefined) {
    searchParams.append("account_shared_uid", account_shared_uid.toString());
  }
  if (campaign_status) {
    searchParams.append("campaign_status", campaign_status);
  }
  if (websiteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", websiteSharedUids[0]);
  }

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  const requestBody = {
    website_shared_uid: websiteSharedUids,
    dimension: dimensions,
  };

  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}

function getOverviewConversionsActivityNotesMobile(
  oauthTokenHeader: string,
  websiteSharedUid: string[],
  fromDate: string,
  toDate: string,
) {
  const searchParams = new URLSearchParams();
  websiteSharedUid.forEach((uid) => {
    searchParams.append("website_shared_uid", uid);
  });
  searchParams.append("from", fromDate);
  searchParams.append("to", toDate);

  const fullUrl = `${apiUrl}/asset_management/activity_notes/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getOverviewConversionsAllUsers(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/admin/users/?active_only=True/`,
    oauthTokenHeader,
  );
}

function getBizMobileBudgetData(params: BizDevelopmentParams) {
  const {
    oauthTokenHeader,
    queryId,
    websiteSharedUids = [],
    type,
    dimension = [],
  } = params;
  const searchParams = new URLSearchParams();
  if (type) {
    searchParams.append("type", type);
  }
  if (websiteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", websiteSharedUids[0]);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  const requestBody = {
    website_shared_uid: websiteSharedUids,
    dimension,
  };
  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}

// Be Aware - Fraud Players
function getBeAwareFraudPlayersData(
  oauthTokenHeader: string,
  queryId: string,
  siteSharedUids: string[],
) {
  const searchParams = new URLSearchParams();
  searchParams.append("territory_name", "all");
  searchParams.append("product_type", "all");
  searchParams.append("geo", "all");
  searchParams.append("industry", "all");
  if (siteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", siteSharedUids[0]);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  const requestBody = {
    website_shared_uid: siteSharedUids,
    dimension: ["bbb_uk"],
  };
  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}

// Be Aware - Negative Balance
function getBeAwareNegativeBalanceData(
  oauthTokenHeader: string,
  queryId: string,
  siteSharedUids: string[],
) {
  const searchParams = new URLSearchParams();
  searchParams.append("territory_name", "all");
  searchParams.append("industry", "all");
  if (siteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", siteSharedUids[0]);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  const requestBody = {
    website_shared_uid: siteSharedUids,
    dimension: ["bbb_uk"],
  };
  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}

// Be Aware - Conversions Upload
function getBeAwareConversionsUploadData(
  oauthTokenHeader: string,
  queryId: string,
  siteSharedUids: string[],
  startDate: string,
  endDate: string,
) {
  const searchParams = new URLSearchParams();
  if (startDate) searchParams.append("start_date", startDate);
  if (endDate) searchParams.append("end_date", endDate);
  searchParams.append("type", "site");
  if (siteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", siteSharedUids[0]);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  const requestBody = {
    website_shared_uid: siteSharedUids,
    dimension: ["bbb_uk"],
  };
  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}

export const bizDevelopmentDashboardMobileService = {
  getOverviewAccountSummaryDataInBizLeaderDashboardMobile,
  getDimensionInBizDashboardMobile,
  getOverviewConversionsMobileData,
  getOverviewConversionsTrafficSourcesMobile,
  getOverviewConversionsGeosMobile,
  getOverviewConversionsFilterOptionsDataForCampaignAdgroupKeyword,
  getOverviewConversionsActivityNotesMobile,
  getOverviewConversionsAllUsers,
  getBizMobileBudgetData,
  getBeAwareFraudPlayersData,
  getBeAwareNegativeBalanceData,
  getBeAwareConversionsUploadData,
};
